import React, {useState} from 'react';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import {Button, Card, Input, message, Space} from 'antd';
import './organization.less';
import {useHistory} from 'react-router-dom';
export default function OrganizationPage() {
  const history = useHistory();
  return (
    <AppSideLayout title={'组织机构'}>
      <Card style={{flex: 1}} title={'组织机构'}>
        <div style={{width: 900}}>
          <div className={'O-BB'} style={{width: 400, marginLeft: 400}}>
            <div className={'OrganizationItem'}>
              会员代表大会 <div className={'O-LineBottom'} />
            </div>
          </div>
          <div style={{display: 'flex', paddingTop: 20, paddingBottom: 20}}>
            <div style={{width: 150, marginLeft: 218}}>
              <div className={'OrganizationItem'} onClick={() => history.push('/organization/党工组')}>
                党工组
                <div className={'O-LineRight'} style={{width: 100, right: -100}} />
              </div>
            </div>
            <div style={{width: 463, display: 'flex', justifyContent: 'space-between'}}>
              <div className={'OrganizationItem'} onClick={() => history.push('/organization/理事会')}>
                理事会
                <div className={'O-LineTop'} />
                <div className={'O-LineBottom'} />
              </div>
              <div className={'OrganizationItem'} onClick={() => history.push('/organization/监事会')}>
                监事会 <div className={'O-LineTop'} />
              </div>
            </div>
          </div>
          <div style={{marginLeft: 100, width: 750, paddingBottom: 20}} className={'O-TB O-TL'}>
            <div style={{display: 'flex', justifyContent: 'space-between', width: 750, marginRight: -72}}>
              {[
                '学术工作委员会',
                '科普工作委员会',
                '咨询工作委员会',
                '组织工作委员会',
                '教育委员会',
                '青年工作委员会',
                '产学研用工作委员会',
                '奖励工作委员会',
                '青少年工作委员会',
                '标准工作委员会',
              ].map(i => (
                <div key={i} className={'OrganizationItem'} style={{width: 75, fontSize: 12, padding: 5}} onClick={() => history.push('/workCommittee/' + i)}>
                  {i === '产学研用工作委员会' ? (
                    <>
                      产学研用 <br />
                      工作委员会
                    </>
                  ) : (
                    <>
                      {i.split('委员会')[0]}
                      <br />
                      委员会
                    </>
                  )}
                  <div className={'O-LineTop'} />
                </div>
              ))}
            </div>
          </div>
          <div style={{width: 700, marginLeft: 50}} className={'O-TB'}>
            <div style={{display: 'flex', justifyContent: 'space-between', width: 728, marginLeft: -31, marginRight: -30}}>
              {[
                '计算机视觉专业委员会',
                '教育信息化专业委员会',
                '自然语言处理专委会',
                '高性能计算专业委员会',
                '人工智能专业委员会',
                '生物信息学专业委员会',
                '协同与信息服务专业委员会',
                '存储专业委员会',
                '网络专业委员会',
                '多媒体专业委员会',
                '软件工程专业委员会',
                '物联网专业委员会',
                '信息安全专业委员会',
                '理论计算机科学专业委员会',
                '普适计算与嵌入式专业委员会',
                '计算机视觉专业委员会',
                '数据库专业委员会',
              ].map(i => (
                <div
                  key={i}
                  className={'OrganizationItem'}
                  style={{width: 30, fontSize: 12, padding: 5}}
                  onClick={() => history.push('/specialtyCommittee/' + i)}>
                  {i}
                  <div className={'O-LineTop'} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </AppSideLayout>
  );
}
